import * as Dialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";
import { Button } from "./Button";
import { Spinner } from "./Spinner";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  loadingLabel?: string;
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void | Promise<void>;
  onOpenChange: (open: boolean) => void;
}

export const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loadingLabel,
  destructive = false,
  loading = false,
  onConfirm,
  onOpenChange
}: ConfirmDialogProps) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" />
      <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-xl border border-slate-800 bg-slate-950 p-6 shadow-2xl focus:outline-none">
        <div className="space-y-2">
          <Dialog.Title className="text-lg font-semibold text-slate-100">{title}</Dialog.Title>
          {description ? (
            <Dialog.Description className="text-sm text-slate-400">
              {description}
            </Dialog.Description>
          ) : null}
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <Dialog.Close asChild>
            <Button variant="ghost" disabled={loading}>
              {cancelLabel}
            </Button>
          </Dialog.Close>
          <Button
            onClick={onConfirm}
            variant={destructive ? "destructive" : "primary"}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size="sm" /> {loadingLabel ?? confirmLabel}
              </>
            ) : (
              confirmLabel
            )}
          </Button>
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
